import { z } from 'zod';
/**
 * `YYYY-MM-DD`, read as a calendar date in the property's timezone, never UTC.
 *
 * Shared by every query that takes a date from a person — the export engine, the Closed
 * archive — so the parsing and the "which midnight" rule are stated once. Resolve it
 * with `propertyRangeBetweenKeys`; never `new Date(key)`, which is still the previous
 * day everywhere behind UTC.
 */
export const propertyDateKeySchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a YYYY-MM-DD calendar date');
//# sourceMappingURL=date-key.js.map